module.exports = __webpack_public_path__ + "static/media/turnLeft.a543b7ab.svg";